import request from '../utils/request';
import { getPartnerToken } from './partner';
// import * as CustomRequest from 'umi-request';
export type sms_type =
  | 'invite'
  | 'register'
  | 'login'
  | 'partner_register'
  | 'partner_login'
  | 'reset_password';
interface SendSmsOption {
  mobile?: string | undefined;
  sms_type: sms_type;
  phone_number?: string | undefined;
}
interface SendEmailOption {
  email: string | undefined;
  sms_type: sms_type;
}

export interface tagsOption {
  binding_count: string;
  id: string;
  name: string;
  type: string;
}

export type tagType = 'knowledge' | 'app';
// 获取当前登录人信息
export const getCurrentUser = () => {
  return request.get('/web/currentUser');
};
// 发送短信验证码 接口
export const sendPhoneSms = (option: SendSmsOption) => {
  return request.post('/api/v1/send/sms', { data: option });
};

// 发送邮箱验证码 接口
export const sendEmail = (option: SendEmailOption) => {
  return request.post('/api/v1/send/email', { data: option });
};

// 判断企业是否已存在
export const getIsExistCompany = (option: { name: string }) => {
  return request.post('/web/user/judge/company', { data: option });
};

// 获取职位列表
export const getJobSelectList = () => {
  return request.get('/v1/user/job/select');
};

// 获取  dify-登录（获取秘钥）
export const getAgentLoginCode = (option: { agent_account_id: string }) => {
  return request.post('/web/user/agent/login', { data: option });
};

//  修改用户名
export const saveSetuserName = (option: { name: string }) => {
  return request.post('/web/user/save', { data: option });
};
// 获取  阿里oss鉴权
export const getAliSts = () => {
  return request.post('/web/ali/sts');
};

// 获取  app dify 图片
export const getAppImg = (id: string) => {
  return request.get(`/files/${id}/image-data`);
};

// 上传  app dify 图片
export const uploadAppImg = (option: { file: File }) => {
  return request.post('/console/api/files/upload', {
    headers: { 'Content-Type': 'multipart/form-data' },
    data: option,
  });
};

// 获取  服务协议
export const getServiceContract = () => {
  return request.get('/v1/conversation/service/contract');
};
// 获取  隐私政策
export const getPrivacyPolicy = () => {
  return request.get('/v1/conversation/privacy/policy');
};

//  获取标签列表
export const getTagsList = (option: { type: tagType }) => {
  return request.get('/console/api/tags', { params: option });
};

//  新增标签
export const createdApiTags = (option: { name: string; type: tagType }) => {
  return request.post('/console/api/tags', { data: option });
};

//  app 新增 选中 标签
export const createAppTag = (option: {
  tag_ids: string[];
  target_id: string;
  type: tagType;
}) => {
  return request.post('/console/api/tag-bindings/create', { data: option });
};

// 取消  app 上的  标签
export const removeAppTag = (option: {
  tag_id: string;
  target_id: string;
  type: tagType;
}) => {
  return request.post('/console/api/tag-bindings/remove', { data: option });
};

//  删除标签
export const removeTagItem = (id: string) => {
  return request.delete(`/console/api/tags/${id}`);
};
//  编辑标签
export const editApiTags = (id: string, option: { name: string }) => {
  return request.patch(`/console/api/tags/${id}`, { data: option });
};

//  编辑知识库信息
export const datasetsKnowledge = (id: string, option: { name: string }) => {
  return request.patch(`/console/api/datasets/${id}`, { data: option });
};

//  获取帮助中心列表
export const getHelpCenterList = () => {
  return request.post('/web/index/help/list');
};

//  获取帮助中心详情
export const getHelpCenterDetail = (option: { id: string }) => {
  return request.post('/web/index/help/detail', { data: option });
};

//  获取帮助中心 搜索
export const searchHelpIndex = (option: { keyword: string }) => {
  return request.post('/web/index/help/search', { data: option });
};

//  智能体分类及智能体名称展示列表
export const getCategoryPreview = () => {
  return request.get('/v1/canvas/category_preview');
};

//  获取  二级联动菜单
export const getSecondaryAnalysis = (option: { file: File }) => {
  const formData = new FormData();
  formData.append('file', option.file);
  return request.post('/v1/canvas/secondary/analysis', {
    data: formData,
  });
};

// 类型定义
export type DictionaryOption = {
  id: string;
  label: string;
  desc: string;
  value: string;
};

//  获取字典
export const getDictionaryList = (key: string) => {
  return request.get('/v1/customform/dictionary', { params: { key } });
};
//  获取 字典 对应的 字段内容
export const getDictionaryField = (role: string) => {
  return request.get('/v1/customform/field', { params: { role } });
};

// ocr-营业执照
export const partnerOcrBusinessLicense = (option: { url: string }) => {
  return request.post('/v1/partner/ocr/business_license', {
    data: option,
    headers: getPartnerToken(),
  });
};

// 获取区域列表
export const getAreaList = (option: { a_level: 0 | 1 | 2; gd_id?: string }) => {
  return request.get('/v1/api/area/list', { params: option });
};
export const CustomRequest = (url:string, option:any)=>{
  return request(url, option)
}



//  获取获取文章（隐私政策、服务协议）
export const  generalArticle = (option: { key: string }) => {
  return request.post('/v1/api/general/article', { data: option });
};